<template>
    <div class="specification"
        :class="{ inactive: !this.visible[this.section] && !this.highlights.includes(this.spec) }">
        <span>{{specs[spec].name}}</span>
        <Tooltip v-if="specs[spec].tooltip" :content="specs[spec].tooltip" />
    </div>
</template>

<script>
import specs from "../constants/specs";
import Tooltip from "./Tooltip.vue";

export default {
    name: "LeftIndex",
    components: { Tooltip },
    props: ["spec", "section", "visible", "highlights"],
    data() {
        return {
            specs,
            name: specs[this.spec].name,
            tooltip: specs[this.spec].tooltip,
        }
    },
};
</script>